import { PayloadAction } from "@reduxjs/toolkit";
import { T_LocalHLBaseData } from "./HL_BaseData_Types";

export const HL_ReduxInitialState = {
  isFetching: false,
  error: undefined,
  success: undefined,
  lastRanApiDetails: undefined,
};
export const HL_HandlingReducerAction = (
  state: T_LocalHLBaseData,
  action: PayloadAction<any, "fetching" | "error" | "success">
) => {
  switch (action.type) {
    case "fetching":
      return { ...state, isFetching: true };
    case "error":
      return {
        ...state,
        error: action.payload as Error,
        success: false,
        isFetching: false,
      };
    case "success":
      return {
        ...state,
        success: true,
        isFetching: false,
        error: undefined,
      };
    default:
      return state;
  }
};
